import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { Link } from '@morningtrain/react-navigation'

export default function ImpersonationBar (props) {
  const [isImpersonating] = useEnvValue('globals.is_impersonating')
  const [nameOfUser] = useEnvValue('user.name')

  if (!isImpersonating) {
    return null
  }

  return (
    <div className='w-full bg-red-500 p-4 space-x-4 text-gray-100'>
      <span>Du imitere brugeren <em>{nameOfUser}</em>.</span>
      <Link route='app.users.users.stop_impersonating' label='Stop Impersonating' />
    </div>
  )
}
